import { Column } from 'react-table';
import { Companies, Processes, SelectOption, Trainings, Users, Zahtjev } from '../types/types';

export const FAQData = [
  {
    title: 'Cursus tellus purus duis in dis sed?',
    content: `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente
      laborum cupiditate possimus labore, hic temporibus velit dicta earum
      suscipit commodi eum enim atque at? Et perspiciatis dolore iure
      voluptatem.`,
  },
  {
    title: 'Tempor, sed pellentesque lorem augue massa sagittis?',
    content: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Mollitia veniam
      reprehenderit nam assumenda voluptatem ut. Ipsum eius dicta, officiis
      quaerat iure quos dolorum accusantium ducimus in illum vero commodi
      pariatur? Impedit autem esse nostrum quasi, fugiat a aut error cumque
      quidem maiores doloremque est numquam praesentium eos voluptatem amet!
      Repudiandae, mollitia id reprehenderit a ab odit!`,
  },
  {
    title: 'Dictum amet, fusce adipiscing scelerisque nam facilisi?',
    content: `Sapiente expedita hic obcaecati, laboriosam similique omnis architecto ducimus magnam accusantium corrupti
      quam sint dolore pariatur perspiciatis, necessitatibus rem vel dignissimos
      dolor ut sequi minus iste? Quas?`,
  },
];

export const ZAHTJEVI_COLUMNS: Column<Zahtjev>[] = [
  {
    Header: 'Name',
    accessor: 'Name',
  },
  {
    Header: 'Size',
    accessor: 'Size',
  },
  {
    Header: 'Uploaded By',
    accessor: 'UploadedBy',
  },
  {
    Header: 'Uploaded At',
    accessor: 'UploadedAt',
  },
  {
    Header: 'Status',
    accessor: 'Status',
  },
  {
    Header: 'RAC',
    accessor: 'DmsID',
  },
  {
    Header: 'Comment',
    accessor: 'InvoiceComment',
  },
];

export const USERS_COLUMNS: Column<Users>[] = [
  {
    Header: 'Id',
    accessor: 'id',
  },
  {
    Header: 'Name',
    accessor: 'username',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'admin',
    accessor: 'admin_role',
  },
];

export const COMPANIES_COLUMNS: Column<Companies>[] = [
  {
    Header: 'Id',
    accessor: 'id',
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'VAT',
    accessor: 'VAT',
  },
  {
    Header: 'Keyword',
    accessor: 'keyword',
  },
  {
    Header: 'AltVAT',
    accessor: 'altVat',
  },
  {
    Header: 'Is Trained',
    accessor: 'isTrained',
  },
  {
    Header: 'Currency',
    accessor: 'currency',
  },
  {
    Header: 'Process Type ID',
    accessor: 'processTypeId',
  },
  {
    Header: 'Group',
    accessor: 'companyGroup',
  },
];

export const PROCESSES_COLUMNS: Column<Processes>[] = [
  {
    Header: 'Name',
    accessor: 'Name',
  },
  {
    Header: 'Version',
    accessor: 'Version',
  },
  {
    Header: 'Modified on',
    accessor: 'ModifiedOn',
  },
  {
    Header: 'Modified by',
    accessor: 'ModifiedBy',
  },
  {
    Header: 'Type',
    accessor: 'Type',
  },
];
export const TRAININGS_COLUMNS: Column<Trainings>[] = [
  {
    Header: '',
    accessor: 'image',
  },
  {
    Header: 'Company',
    accessor: 'company',
  },
  {
    Header: 'VAT',
    accessor: 'VAT',
  },
  {
    Header: 'Date trained',
    accessor: 'dateTrained',
  },
  {
    Header: 'Trained by',
    accessor: 'trainedBy',
  },
];

export const DOCUMENTS_BY_PROCESS_COLUMNS: Column<any>[] = [
  {
    Header: 'Process type ID',
    accessor: 'processTypeId',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
];

export const statusZahtjeva: SelectOption[] = [
  { value: 0, label: 'In Queue' },
  { value: 1, label: 'In progress' },
  { value: 2, label: 'Ready' },
  { value: 3, label: 'Confirmed' },
  { value: 4, label: 'Problem' },
  { value: 5, label: 'Archived' },
  { value: 7, label: 'Confirmed' },
];

export const documentVariableNames = [
  { key: 'ID', label: 'ID' },
  { key: 'Name', label: 'Name' },
  { key: 'Size', label: 'Size' },
  { key: 'UploadedBy', label: 'Uploaded by' },
  { key: 'UploadedAt', label: 'Uploaded at' },
  { key: 'Status', label: 'Status' },
  { key: 'CompanyName', label: 'Company name' },
  { key: 'SupplierName', label: 'Supplier name' },
  { key: 'InvoiceGroup', label: 'Invoice group' },
  { key: 'CompanyVAT', label: 'Company VAT' },
  { key: 'InvoiceNumber', label: 'Invoice number' },
  { key: 'InvoiceDate', label: 'Invoice date' },
  { key: 'InvoiceDueDate', label: 'Invoice due date' },
  { key: 'InvoiceSubtotal', label: 'Invoice subtotal' },
  { key: 'InvoiceTotal', label: 'Invoice total' },
  { key: 'InvoiceCurrency', label: 'Invoice currency' },
  { key: 'ProcessID', label: 'Process ID' },
  { key: 'DmsID', label: 'Dms ID' },
  { key: 'InvoiceType', label: 'Invoice type' },
  { key: 'InvoiceState', label: 'Invoice state' },
  { key: 'InvoiceOrderNumber', label: 'Invoice order number' },
  { key: 'InvoiceReferenceNumber', label: 'Invoice reference number' },
  { key: 'InvoiceConfirmationNumber', label: 'Invoice confirmation number' },
  { key: 'InvoiceRecipient', label: 'Invoice recipient' },
  { key: 'InvoiceComment', label: 'Invoice comment' },
  { key: 'ModifiedBy', label: 'Modified by' },
  { key: 'ModifiedAt', label: 'Modified at' },
];

export const statisticsDropdown = [
  { key: 'year', label: 'This year' },
  { key: 'month', label: 'This month' },
  { key: 'week', label: 'This week' },
];
